import { useMemo } from "react";
import { AlertCircle, FolderKanban, Warehouse } from "lucide-react";
import { useWorkspace } from "../../context/WorkspaceContext";
import { useAuth } from "../../context/AuthContext";
import { SearchableSelect } from "../common/SearchableSelect";

const ALL = "__ALL__";

export function ContextSwitcher() {
  const { ctx, setContext, options } = useWorkspace();
  const { user } = useAuth();

  const stores = (options.stores || []).filter((s) => !ctx.project || s.project_id === ctx.project.id);
  const noScope = !user?.is_admin && (options.projects || []).length === 0;

  const projectOpts = useMemo(() => [
    { value: ALL, label: "All Projects", sub: "Aggregated view" },
    ...(options.projects || []).map((p) => ({ value: p.id, label: p.project_code ? `${p.project_code} — ${p.project_name}` : p.project_name, sub: p.client || p.location })),
  ], [options.projects]);
  const storeOpts = useMemo(() => stores.map((s) => ({ value: s.id, label: s.store_code ? `${s.store_code} — ${s.store_name}` : s.store_name, sub: s.location })), [stores]);

  const guardedChange = (fn) => {
    if (window.__erpUnsaved && !window.confirm("You have unsaved changes. Changing the Project may discard this entry. Continue?")) return;
    window.__erpUnsaved = false;
    fn();
  };

  const changeProject = (v) => guardedChange(() => {
    if (!v || v === ALL) return setContext(null, null);
    setContext((options.projects || []).find((x) => x.id === v) || null, null);
  });
  const changeStore = (v) => setContext(ctx.project, stores.find((x) => x.id === v) || null);

  if (noScope) {
    return <div className="flex items-center gap-1.5 rounded-md bg-amber-50 px-2.5 py-1.5 text-xs font-medium text-amber-700" data-testid="active-context-switcher"><AlertCircle className="h-3.5 w-3.5" /> No project assigned</div>;
  }

  return (
    <div className="flex items-center gap-2" data-testid="active-context-switcher">
      <FolderKanban className="h-4 w-4 text-[#0e5b6b]" />
      <div className="w-72 lg:w-96"><SearchableSelect testid="active-project-select" value={ctx.project?.id || ALL} onChange={changeProject} options={projectOpts} placeholder="All Projects" className="border-[#0e5b6b]/40 bg-[#e8f4f6] font-medium text-[#0e5b6b] hover:bg-[#dcedf0] focus-visible:ring-2 focus-visible:ring-[#0e5b6b]/30" /></div>
      <Warehouse className="h-4 w-4 text-slate-400" />
      <div className="w-48"><SearchableSelect testid="active-store-select" value={ctx.store?.id || ""} onChange={changeStore} options={storeOpts} placeholder="Active Store" disabled={!ctx.project} /></div>
    </div>
  );
}
